var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:['main', { 'main-header': _vm.isPopup }]},[_c('div',{class:([_vm.isMobile ? 'nav-items' : 'd-none d-lg-block'], 'main__inner')},[_c('nav',{staticClass:"nav-menu d-flex justify-content-between"},[_c('div',{staticClass:"nav-items"},[_c('router-link',{attrs:{"to":{ name: 'main' }}},[_c('Logo')],1)],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }